module.exports = __webpack_public_path__ + "img/evalyellow.b978a788.svg";